__turbopack_context__.v({
  "contentWrapper": "OTP-module__lXl2wq__contentWrapper",
  "inputField": "OTP-module__lXl2wq__inputField",
  "main": "OTP-module__lXl2wq__main",
  "otpWrapper": "OTP-module__lXl2wq__otpWrapper",
  "validateCodeError": "OTP-module__lXl2wq__validateCodeError",
});
